<template>
	<div
		:class="['panel', 'corporate-participant',
			isHeaderIndent? 'mt-0 pt-1' : '',
			isFooterIndent? 'mb-0 pb-1' : '',
			block.appearance? block.appearance : ''
		]"
	>
		<div v-if="block.is_accordion" class="container">
			<b-card no-body class="pane">
				<b-card-header header-tag="header" class="p-0" role="tab">
					<div v-b-toggle="'module-collapse-' + block.id" class="accordeon-pane">
						{{ block.block_title }}
					</div>
				</b-card-header>
				<client-only>
					<b-collapse :id="'module-collapse-' + block.id" class="theme-white" role="tabpanel">
						<b-card-body>
							<div class="row mb-3">
								<div class="col-12 col-lg-6">
									<div class="head-block">
										<b-img-lazy v-if="block.image" :src="block.image" alt />
										<div v-if="block.title" class="title">
											{{ block.title }}
										</div>
										<div v-if="block.text_left" class="description" v-html="block.text_left" />
									</div>
								</div>

								<div class="col-12 col-lg-6">
									<div class="icons-block">
										<ul class="row">
											<li
												v-for="(item, index) in block.items"
												:key="index"
												class="col-12 col-sm-6"
											>
												<div class="item">
													<div v-if="item.icon" :class="['icon', item.icon]" />
													<div v-if="item.title" class="title">
														{{ item.title }}
													</div>
												</div>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</b-card-body>
					</b-collapse>
				</client-only>
			</b-card>
		</div>
		<div v-else class="container">
			<div
				v-if="isHeaderVisible"
				:class="[
					'panel_header',
					isBrand? 'sk' : '',
				]"
			>
				<h2>{{ block.block_title }}</h2>
			</div>

			<div class="row mb-3">
				<div class="col-12 col-lg-6">
					<div class="head-block">
						<b-img-lazy v-if="block.image" :src="block.image" alt />
						<div v-if="block.title" class="title">
							{{ block.title }}
						</div>
						<div v-if="block.text_left" class="description" v-html="block.text_left" />
					</div>
				</div>

				<div class="col-12 col-lg-6">
					<div class="icons-block">
						<ul class="row">
							<li
								v-for="(item, index) in block.items"
								:key="index"
								class="col-6 col-sm-6"
							>
								<div class="item">
									<div v-if="item.icon" :class="['icon', item.icon]" />
									<div v-if="item.title" class="title">
										{{ item.title }}
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>

			<div v-if="isFooterVisible" class="panel_footer">
				<dynamic-button
					:button="block.button"
					:block-id="block.id"
					:scenario="block.scenario"
				/>
				<!--<panel-footer v-else :block="block"/>-->
			</div>
		</div>
	</div>
</template>

<script>
import panel from '~/mixins/panel';

export default {
	name: 'PanelCard02',
	mixins: [panel],
};
</script>

<style lang="scss" scoped>
@import "~/assets/styles/components/home/panel-corporate-participant";

.accordeon-pane {
	position: relative;
	padding: 1.5rem 4rem 1.5rem 1rem;
	font-size: 1rem;
	line-height: 1;
	font-weight: bold;
	color: $body-color;
	outline: 0;
	cursor: pointer;

	span {
		font-weight: 500;
	}

	// Это добавка готовности/не готовности карточки соотв. участника. Можно не использовать.
	&::before {
		content: "";
		display: block;
		position: absolute;
		font-family: "sk_icons";
		font-size: 1rem;
		font-weight: normal;
		// margin-right: 0.5rem;
		left: 1rem;
	}

	&::after {
		position: absolute;
		display: block;
		content: "\e93f";
		font-family: "sk_icons";
		font-size: 1rem;
		font-weight: normal;
		right: 1.5rem;
		top: 1.5rem;
	}

	&.collapsed {
		&::after {
			content: "\e940";
		}
	}
}
</style>
